import React from 'react'
import './Board.css'

const Board = (props) => {

    return (
        <div className="board-container" style={{width: props.gameWidth, gridTemplateColumns: "repeat("+ props.size + ", auto)"}}>
            {props.boardValues.map((v) => {
                return <div className={props.done ? "cell_disabled" : "cell"} 
                    key={v}
                    style={{
                        width: props.gameWidth / props.size + "px",
                        height: props.gameWidth / props.size + "px",
                        fontSize: (props.gameWidth / props.size) * 0.4 + "px",
                    }}
                    onClick={() => props.done ? null : props.clicked(v)}>{v}</div>
            })}
        </div>
    )
}

export default Board
